var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "div",
        _vm._l(_vm.num, function(i) {
          return _c(
            "el-form-item",
            {
              key: i,
              attrs: {
                label: `${_vm.label}（第${i}${_vm.unit}）`,
                prop: `${_vm.prop}.${i - 1}`,
                rules: _vm.rules
              }
            },
            [
              _c("el-input", {
                attrs: {
                  readonly: _vm.readonly,
                  size: "mini",
                  placeholder: "请输入",
                  value: _vm.value[i - 1]
                },
                on: {
                  input: function($event) {
                    return _vm.input(i - 1, $event)
                  }
                }
              })
            ],
            1
          )
        }),
        1
      )
    : _c("el-form-item", { attrs: { label: _vm.label } }, [_vm._v(" -- ")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }